import React from 'react'
import { translate } from 'react-i18next'
import VoiceItem from '../../VoiceItem'
import { Routes } from '../../../utils/constants'
import SimpleLink from '../../SimpleLink'
import './index.sass'

const AudioContent = ({
  title,
  text,
  audioList,
  hasVoiceSescr,
  changeModalVisibility,
  toggleFavoriteVoice,
  toggleVisibleAudioPlayer,
  setPlayingStatus,
  currentPlayingVoice,
  setPlayingVoiceId,
  setChoosenVoice,
  t,
  lng,
}) => {
  return (
    <div className="audio-content">
      {title && <h4 className="subtitle-1">{title}</h4>}
      <div className="audio-video-content">
        <p className="body-light">{text}</p>
        {audioList.map(elem => (
          <VoiceItem
            key={elem.id}
            changeModalVisibility={changeModalVisibility}
            voiceItem={elem}
            toggleFavoriteVoice={toggleFavoriteVoice}
            toggleVisibleAudioPlayer={toggleVisibleAudioPlayer}
            setPlayingStatus={setPlayingStatus}
            currentPlayingVoice={currentPlayingVoice}
            setPlayingVoiceId={setPlayingVoiceId}
            setChoosenVoice={setChoosenVoice}
            hasVoiceSescr={hasVoiceSescr}
          />
        ))}
      </div>
      <SimpleLink
        route={lng === 'en' ? Routes.VOICES : `/${lng}${Routes.VOICES}`}
        text={t('navigations.voices')}
      />
    </div>
  )
}

export default translate('translations')(AudioContent)
